export const NOTIFICATION_LIST = 'NOTIFICATION_LIST';
